module.exports = __webpack_public_path__ + "media/images/underline-lime-7be16e3e2b933f263f126cc637b2770b.svg";